import {Injectable, signal, WritableSignal} from '@angular/core';
import {BaseApiService} from "../base-api-service/base-api.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiStandardReturn} from "../../models/api-standard-return";
import {catchError, EMPTY, finalize, take, tap} from "rxjs";

/**
 * Loads resource from backend REST API and exposes signals for request state.
 */
@Injectable({
  providedIn: 'root'
})
export abstract class ResourceLoaderService<T> extends BaseApiService {
  private _loading: WritableSignal<boolean> = signal(true);
  loading = this._loading.asReadonly();

  private _error: WritableSignal<HttpErrorResponse | null> = signal(null);
  error = this._error.asReadonly();

  private _content: WritableSignal<T | null> = signal(null);
  content = this._content.asReadonly();

  load(resource: string) {
    this._loading.set(true);
    this._error.set(null);

    this.http.get<ApiStandardReturn<T>>(this.apiUrl + resource).pipe(
      take(1),
      tap(response => {
        this._content.set(response.data);
      }),
      catchError((error: HttpErrorResponse) => {
        this._error.set(error);
        return EMPTY;
      }),
      finalize(() => this._loading.set(false))
    ).subscribe();
  }
}
